import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { challengePath } from '../lib/twoFactor/firstFactor'
import { useTwoFactorChallengeStore } from '../store/twoFactorChallengeStore'
import type { FirstFactorOutcome } from '../app/modules/types/twoFactor'

/**
 * Send a first-factor outcome where it goes: a session continues with the
 * caller's own `onSession`, a challenge parks its token in memory and opens the
 * verify or setup screen.
 *
 * Every first-factor handler (password login, social login, activation) calls
 * this instead of assuming that "no error" means "signed in".
 */
export function useFirstFactorRouter() {
  const navigate = useNavigate()
  const begin = useTwoFactorChallengeStore((s) => s.begin)
  return useCallback(
    (outcome: FirstFactorOutcome, onSession: () => void) => {
      if (outcome.kind === 'session') {
        onSession()
        return
      }
      begin(outcome.kind, outcome.challengeToken, outcome.expiresIn)
      const path = challengePath(outcome)
      if (path) navigate(path, { replace: true })
    },
    [begin, navigate],
  )
}
